(() => {
  'use strict';
  const config = JSON.parse(document.getElementById('ThemeConfig')?.textContent || '{}');
  const root = (config.root || '/').replace(/\/?$/, '/');
  const commerce = JSON.parse(document.getElementById('CommerceConfig')?.dataset.config || '{}');
  let cartCurrency=config.currency||'USD';
  const money = (cents,alwaysCode=false,currency=cartCurrency) => window.PawCommerceEngine.money(cents,currency,config.locale||'en',alwaysCode||commerce.currencyCodes);
  const announce = (message) => {
    const live = document.querySelector('[data-live-region]');
    if (live) live.textContent = message;
  };
  const drawer = document.querySelector('[data-cart-drawer]');
  let cartBusy = false;
  let badgeRevision = 0;
  let cartChanged = false;
  const dialogTriggers = new WeakMap();
  const readyDialogs = new WeakSet();
  function openDialog(dialog, trigger) {
    if (!dialog) return;
    initialiseDialog(dialog);
    if (trigger) { dialogTriggers.set(dialog, trigger); trigger.setAttribute('aria-expanded', 'true'); }
    if (!dialog.open) dialog.showModal();
  }
  async function requestCart(path, options = {}) {
    const response = await fetch(root + path, { credentials: 'same-origin', ...options });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || config.strings.error);
    return result;
  }
  async function refreshCartBadges(cart, revision) {
    if ((!config.preorderCartBadge && !commerce.subtitle) || !cart.items.length) return;
    try {
      const sections = await requestCart('cart?sections=cart-badges');
      if (revision !== badgeRevision || !sections?.['cart-badges']) return;
      const doc = new DOMParser().parseFromString(sections['cart-badges'], 'text/html');
      const byKey = new Map([...doc.querySelectorAll('[data-cart-badge-key]')].map(node => [node.dataset.cartBadgeKey, node]));
      document.querySelectorAll('[data-line-badges]').forEach(node => {
        const badge = byKey.get(node.dataset.lineKey)?.querySelector('[data-badge="preorder"]');
        if (badge) node.replaceChildren(badge.cloneNode(true));
        const subtitle=node.closest('.drawer-line').querySelector('[data-line-subtitle]');
        if(subtitle&&commerce.subtitle)subtitle.textContent=byKey.get(node.dataset.lineKey)?.querySelector('[data-cart-subtitle]')?.textContent||'';
      });
    } catch { /* Badge lookup failure must never interrupt a basket update. */ }
  }
  function createCartLine(item) {
      const line = document.getElementById('CartLineTemplate').content.cloneNode(true);
      line.querySelector('[data-line-link]').href = item.url;
      const title = line.querySelector('[data-line-title]'); title.textContent = item.product_title; title.href = item.url;
      const image = line.querySelector('[data-line-image]');
      if (item.image) { image.src = item.image; image.alt = item.product_title; } else { image.hidden = true; }
      const details = [];
      if (item.variant_title && item.variant_title !== 'Default Title') details.push(item.variant_title);
      if (item.selling_plan_allocation?.selling_plan?.name) details.push(item.selling_plan_allocation.selling_plan.name);
      Object.entries(item.properties || {}).forEach(([key, value]) => {
        if (!key.startsWith('_') && value) details.push(`${key}: ${value}`);
      });
      line.querySelector('[data-line-variant]').textContent = details.join(' · ');
      line.querySelector('[data-line-badges]').dataset.lineKey = item.key;
      line.querySelector('[data-line-price]').textContent = money(item.final_line_price,true);
      line.querySelector('.drawer-line').dataset.variantId=item.id;
      line.querySelector('[data-line-vendor]').textContent=commerce.vendor?(item.vendor||item.product?.vendor||''):'';
      line.querySelector('[data-line-sku]').textContent=commerce.sku&&item.sku?config.strings.sku+': '+item.sku:'';
      line.querySelector('[data-line-quantity]').textContent = item.quantity;
      [[ '[data-line-minus]', item.quantity - 1 ], [ '[data-line-plus]', item.quantity + 1 ], [ '[data-line-remove]', 0 ]].forEach(([selector, quantity]) => {
        const button = line.querySelector(selector);
        button.dataset.cartKey = item.key; button.dataset.cartQuantity = quantity;
      });
      return line;
  }
  function displayCart(cart) {
    const revision = ++badgeRevision;
    cartCurrency=typeof cart.currency==='string'?cart.currency:cart.currency?.iso_code||config.currency||'USD';
    document.dispatchEvent(new CustomEvent('paw:cart',{detail:{cart}}));
    document.querySelectorAll('[data-cart-count]').forEach(node => { node.textContent = cart.item_count; });
    if (!drawer) {refreshCartBadges(cart,revision);return;}
    const body = drawer.querySelector('[data-cart-items]');
    const footer = drawer.querySelector('[data-cart-footer]');
    body.replaceChildren();
    if (!cart.items.length) {
      const empty = document.createElement('div'); empty.className = 'empty-state';
      const heading = document.createElement('h3'); heading.textContent = config.strings.empty;
      const message = document.createElement('p'); message.textContent = config.strings.emptyText;
      const link = document.createElement('a'); link.href = commerce.continueUrl || root + 'collections'; link.className = 'button'; link.textContent = config.strings.continue;
      empty.append(heading, message, link); body.append(empty);
    }
    cart.items.forEach(item=>body.append(createCartLine(item)));
    footer.hidden = !cart.items.length;
    drawer.querySelector('[data-cart-total]').textContent = money(cart.total_price,true);
    drawer.querySelectorAll('[data-cart-promo]').forEach(el=>el.hidden=cart.items.length>0);
    const note=drawer.querySelector('[data-cart-note]');if(note&&document.activeElement!==note)note.value=cart.note||'';
    refreshCartBadges(cart, revision);
  }
  async function changeCart(key, quantity, control) {
    if (cartBusy) return;
    cartBusy = true;
    drawer.querySelector('[data-cart-error]').textContent = '';
    drawer.querySelectorAll('[data-cart-key]').forEach(button => { button.disabled = true; });
    try {
      const cart = await requestCart('cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity })
      });
      const scroll = drawer.querySelector('[data-cart-items]').scrollTop;
      displayCart(cart); cartChanged = true; announce(config.strings.updated);
      drawer.querySelector('[data-cart-items]').scrollTop = scroll;
      const replacement = [...drawer.querySelectorAll('[data-cart-key]')].find(button => button.dataset.cartKey === key && button.hasAttribute(control));
      (replacement || drawer.querySelector('[data-close-dialog]')).focus();
    } catch (error) { drawer.querySelector('[data-cart-error]').textContent = error.message; }
    finally {
      cartBusy = false; drawer.querySelectorAll('[data-cart-key]').forEach(button => { button.disabled = false; });
    }
  }
  document.addEventListener('click', async event => {
    const open = event.target.closest('[data-open-dialog]');
    if (open) openDialog(document.getElementById(open.dataset.openDialog), open);
    const close = event.target.closest('[data-close-dialog]');
    if (close) close.closest('dialog')?.close();
    const cartTrigger = event.target.closest('[data-open-cart]');
    if (cartTrigger && drawer) {
      event.preventDefault(); openDialog(drawer, cartTrigger);
      drawer.querySelector('[data-cart-error]').textContent = '';
      try { displayCart(await requestCart('cart.js')); }
      catch (error) { drawer.querySelector('[data-cart-error]').textContent = error.message; }
    }
    const cartButton = event.target.closest('[data-cart-key]');
    if (cartButton) await changeCart(cartButton.dataset.cartKey, Number(cartButton.dataset.cartQuantity), cartButton.hasAttribute('data-line-plus') ? 'data-line-plus' : cartButton.hasAttribute('data-line-minus') ? 'data-line-minus' : 'data-line-remove');
    const quantityButton = event.target.closest('[data-quantity-change]');
    if (quantityButton) {
      const input = quantityButton.closest('.quantity').querySelector('input');
      const min = Number(input.min || 1), step = Number(input.step || 1);
      const max = input.max ? Number(input.max) : Infinity;
      const permittedMax = Number.isFinite(max) ? min + Math.floor((max - min) / step) * step : max;
      input.value = Math.min(permittedMax, Math.max(min, Number(input.value || min) + Number(quantityButton.dataset.quantityChange) * step));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    const thumbnail = event.target.closest('[data-thumbnail]');
    if (thumbnail) {
      const section = thumbnail.closest('[data-product-section]');
      const image = section.querySelector('[data-main-image]');
      if (image) { image.src = thumbnail.dataset.thumbnail; image.removeAttribute('srcset'); image.alt = thumbnail.dataset.imageAlt; }
      section.querySelectorAll('[data-thumbnail]').forEach(button => button.setAttribute('aria-pressed', String(button === thumbnail)));
    }
  });
  function initialiseDialog(dialog) {
    if(readyDialogs.has(dialog))return;readyDialogs.add(dialog);
    dialog.addEventListener('click', event => {
      if (event.target !== dialog || dialog.matches('[data-age-gate]')) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      const trigger = dialogTriggers.get(dialog); trigger?.setAttribute('aria-expanded', 'false'); trigger?.focus();
      if (dialog.matches('[data-cart-drawer],[data-cart-notification]') && cartChanged && document.body.classList.contains('template-cart')) window.PawCart?.saveNote().then(()=>window.location.reload()).catch(()=>announce(config.strings.error));
    });
  }
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-product-form]');
    if (!form || event.defaultPrevented) return;
    event.preventDefault();
    const submit = event.submitter || document.querySelector(`[form="${CSS.escape(form.getAttribute('id') || '')}"][type="submit"]`) || form.querySelector('[type="submit"]');
    if (!submit || submit.disabled || cartBusy) return;
    const errorNode = form.querySelector('[data-form-error]') || form.closest('[data-product-section]')?.querySelector('[data-form-error]');
    if (errorNode) errorNode.textContent = '';
    submit.disabled = true; submit.setAttribute('aria-busy', 'true'); cartBusy = true;
    const select = form.elements.namedItem('id');
    const payload = new FormData(form);
    if (select) select.disabled = true;
    let added = false;
    try {
      await requestCart('cart/add.js', { method: 'POST', body: payload });
      added = true; cartChanged = true;
      const cart=await requestCart('cart.js');displayCart(cart);
      window.PawCart?.afterAdd(cart,submit,[Number(payload.get('id'))]);announce(config.strings.added);
    } catch (error) {
      // An add may succeed even if the following read fails. Never retry a cart mutation automatically.
      const message = added ? config.strings.added_review : error.message;
      if (errorNode) errorNode.textContent = message;
      announce(message);
    } finally { submit.disabled = false; if (select) select.disabled = false; submit.removeAttribute('aria-busy'); cartBusy = false; }
  });
  function initialiseProduct(section) {
    if (section.hasAttribute('data-product-experience')) return;
    if (section.dataset.productInitialised) return;
    section.dataset.productInitialised = 'true';
    const variants = JSON.parse(section.querySelector('[data-product-variants]')?.textContent || '[]');
    const inventory = JSON.parse(section.querySelector('[data-variant-inventory]')?.textContent || '{}');
    const select = section.querySelector('[data-variant-select]');
    if (!select) return;
    select.addEventListener('change', () => {
      const variant = variants.find(item => String(item.id) === select.value);
      if (!variant) return;
      const stock = inventory[variant.id] || {};
      section.querySelectorAll('[data-add-button]').forEach(button => {
        button.disabled = !variant.available;
        button.textContent = variant.available ? (section.dataset.preorder === 'true' && stock.managed && stock.policy === 'continue' && stock.quantity <= 0 ? config.strings.preorder : config.strings.add) : config.strings.soldOut;
      });
      section.querySelectorAll('[data-product-price]').forEach(price => {
        price.replaceChildren();
        const priceText = document.createElement('span'); priceText.className = 'price'; priceText.textContent = money(variant.price); price.append(priceText);
        if (variant.compare_at_price > variant.price) { const oldPrice = document.createElement('s'); oldPrice.textContent = money(variant.compare_at_price); priceText.classList.add('price--sale'); priceText.append(oldPrice); }
      });
      if (variant.featured_image?.src) { const image = section.querySelector('[data-main-image]'); if (image) { image.src = variant.featured_image.src; image.alt=variant.featured_image.alt||section.querySelector('h1')?.textContent||''; image.removeAttribute('srcset'); } }
      const quantity = section.querySelector('input[name="quantity"]');
      if (quantity) { const rule = variant.quantity_rule || {}; quantity.min = rule.min || 1; quantity.step = rule.increment || 1; quantity.max = rule.max || ''; quantity.value = quantity.min; }
      section.querySelectorAll('[data-select-variant]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.selectVariant === select.value)));
      section.querySelectorAll('[data-dynamic-variant]').forEach(input => {input.value = variant.id;input.closest('form').hidden = !variant.available;});
      section.dispatchEvent(new CustomEvent('paw:variant',{bubbles:true,detail:{id:variant.id,available:variant.available,preorder:!!stock.managed&&stock.policy==='continue'&&stock.quantity<=0}}));
      section.querySelectorAll('[data-stock-request]').forEach(node => node.hidden = variant.available);
      section.querySelectorAll('[data-stock-body]').forEach(node => node.value = `Availability request: ${section.querySelector('h1')?.textContent} — ${variant.title} — ${location.origin}/products/${section.dataset.productHandle}?variant=${variant.id}`);
      section.querySelectorAll('[data-inventory-note]').forEach(node => node.textContent = stock.managed && stock.quantity > 0 && stock.quantity <= Number(node.dataset.threshold) ? `${config.strings.onlyLeft} ${stock.quantity}` : '');
      if (!section.hasAttribute('data-featured-product') && !section.closest('[data-quick-view-content]')) { const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); window.history.replaceState({}, '', url); }
    });
  }
  function initialise(scope = document) {
    scope.querySelectorAll('dialog').forEach(initialiseDialog);
    scope.querySelectorAll('[data-product-section]').forEach(initialiseProduct);
    if (scope.matches?.('[data-product-section]')) initialiseProduct(scope);
    window.PawStudio?.initialise(scope);window.PawSectionTools?.initialise(scope);window.PawMerchantTools?.initialise(scope);window.PawCompletion?.initialise(scope);
    scope.querySelectorAll('[data-recommendations]').forEach(async element => {
      if (element.querySelector('.product-grid') || element.dataset.loading) return;
      element.dataset.loading = 'true';
      try {
        const response = await fetch(element.dataset.url, { credentials: 'same-origin' });
        if (!response.ok) return;
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = doc.querySelector('[data-recommendations]');
        if (content?.querySelector('.product-grid')) { element.replaceChildren(...content.childNodes); element.hidden = false; }
      } catch { /* Recommendations are optional; the product form remains available. */ }
    });
  }
  async function addItems(items, trigger) {
    if (cartBusy) throw new Error(config.strings.busy || 'Please wait for your basket to update.');
    cartBusy = true; let added = false;
    try {
      await requestCart('cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items }) });
      added = true; cartChanged = true;
      const cart=await requestCart('cart.js');displayCart(cart);window.PawCart?.afterAdd(cart,trigger,items.map(item=>Number(item.id)));announce(config.strings.added);
    } catch (error) { throw new Error(added ? config.strings.added : error.message); }
    finally { cartBusy = false; }
  }
  window.PawTheme = { createCartLine, initialise, requestCart, displayCart, openDialog, announce, addItems, money, config };
  initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
  document.addEventListener('change', event => { if (event.target.matches('[data-auto-submit]')) event.target.form.requestSubmit(); });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') document.querySelectorAll('[data-nav-details][open]').forEach(node => { node.open = false; node.querySelector('summary').focus(); }); });
  document.addEventListener('click', event => { document.querySelectorAll('[data-nav-details][open]').forEach(node => { if (!node.contains(event.target)) node.open = false; }); });
})();
